module.exports = __webpack_public_path__ + "img/Ron.c84fdb1f.jpg";